<!-- Side Contactform  -->
<div id="mySidepanel" class="sidepanel">
    <div class="form2">
        <div fxLayout="column wrap">
            <div class="headContent">
                <span class="head"> <b> Depot Directory</b></span>
                <i id="closeX" (click)="closeDD()" class="flaticon-close"></i>
            </div>
            <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-xs="12em" fxLayout="column">
                    <div class="inputTitle">
                        <span>First Name*</span>
                    </div>
                    <app-text-field [data]="" [isEditable]="isEditable" [(ngModel)]="contactObject.first_name"
                        [name]="'first_name'" [maxlength]="10" [minlength]="3" [errors]="errorObj.first_name">
                    </app-text-field>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="12em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Last Name</span>
                    </div>
                    <app-text-field [data]="" [isEditable]="isEditable" [(ngModel)]="contactObject.last_name"
                        [name]="'last_name'" [maxlength]="10" [errors]="errorObj.last_name">
                    </app-text-field>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="12em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Designation</span>
                    </div>
                    <app-text-field [data]="" [isEditable]="isEditable" [name]="'profile'"
                        [(ngModel)]="contactObject.profile" [maxlength]="50" [minlength]="5">
                    </app-text-field>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="12em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Mobile No</span>
                    </div>
                    <app-phone-field [isEditable]="isEditable" [(ngModel)]="contactObject.phone" [name]="'phone'"
                        [errors]="errorObj.phone">
                    </app-phone-field>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="26.4em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Email ID*</span>
                    </div>
                    <app-text-field [data]="" [isEditable]="isEditable" [placeholder]="''"
                        [(ngModel)]="contactObject.email" [name]="'email'" [maxlength]="100" [minlength]="5"
                        class="ai-fxs" [errors]="errorObj.email">
                    </app-text-field>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="26.4em" fxLayout="column">
                    <div class="inputTitle">
                        <span>Function</span>
                    </div>
                    <app-text-field [data]="" [isEditable]="isEditable" [placeholder]="''"
                        [(ngModel)]="contactObject.function" [name]="'function'" [maxlength]="50" [minlength]="5"
                        class="ai-fxs" [errors]="errorObj.function">
                    </app-text-field>
                </div>
                <div class="ai-fxs" fxFlex="26.4em" fxLayout="column">
                    <section>
                        <mat-checkbox color="primary" [(ngModel)]="contactObject.is_active" [name]="'is_active'" checked
                            [disabled]="!isEditable">Active</mat-checkbox>
                    </section>
                </div>

                <div fxFlex="100" class="btnb">
                    <ng-container *ngIf="isEditable">
                        <button mat-raised-button class="nxt" (click)="onContactSave()" class="Save"> Save</button>
                    </ng-container>
                    <!-- <ng-container *ngIf="!isEditable">
                        <button mat-raised-button class="nxt" (click)="contactEdit()" class="Save"> Edit</button>
                    </ng-container> -->
                </div>
            </div>
        </div>
    </div>
</div>
<div id="mySidepanel1" class="sidepanel">
    <div id="form2">
        <div fxLayout="column wrap">
            <div class="headContent">
                <span class="head"> <b> Assign Communications</b></span>
                <i id="closeX" class="flaticon-close-window"></i>
            </div>
            <div fxFlex="100" class="inputs" fxLayout="row wrap">
                <div fxFlex="12em" fxLayout="column">
                    table
                </div>

                <div class="btnb">
                    <button mat-stroked-button class="nxt">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>

<cdk-depot-stepper class="relaxed" id="customStepper" #badStepper>
    <cdk-step>
        <div id="top"></div>
        <ng-template cdkStepLabel>Basic Details</ng-template>
        <div class="proBg">
            <mat-progress-bar id="progressBar" class="progressSlider" mode="determinate" value="{{counter}}">
            </mat-progress-bar>
        </div>
        <div class="formLayout form1">
            <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
            <div class="content form-group" id="card1" fxLayout="column wrap" *ngIf="!loader">
                <div class="headContent d-flex justify-content-between">
                    <button mat-icon-button (click)="backToList()" class="backArrow">
                        <i class="flaticon-back-arrow"></i>
                    </button>
                    <span class="head"><b> Introductory Details</b></span>
                </div>

                <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                    <!-- <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Type of Depot*</span>
                        </div>
                        <app-select-field [isEditable]="isEditable" [idField]="null" [name]="'depot_owner_type'"
                            [displayField]="'value'" [options]="dd_depotTypes?.results"
                            [errors]="errorObj.depot_owner_type">
                        </app-select-field>
                    </div> -->
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Type of Depot*</span>
                        </div>
                        <app-select-field [isEditable]="isEditable" [idField]="null"
                            [(ngModel)]="depotObject.depot_owner_type" [name]="'depot_owner_type'"
                            [displayField]="'value'" [options]="dd_depotTypes?.results"
                            [errors]="errorObj.depot_owner_type">
                        </app-select-field>
                    </div>
                    <!-- (ngModelChange)="editDepotType($event)" -->
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Depot Name*</span>
                        </div>
                        <app-edit-suggestion-field [isEditable]="isEditable" [displayField]="'name'" [name]="'name'"
                            [(ngModel)]="depotObject.name" [minlength]="3"
                            [listUrl]="base_url+'location/?location_type_name=depot&name=::search::'"
                            (onSelect)="editDepotMaster($event)" [errors]="errorObj.name">
                        </app-edit-suggestion-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Local name of Depot</span>
                        </div>
                        <app-text-field [data]="" [isEditable]="isEditable" [(ngModel)]="depotObject.local_name"
                            [minlength]="3" [name]="'local_name'" [maxlength]="100" [minlength]="5"
                            [errors]="errorObj.local_name">
                        </app-text-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Country*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [name]="'country'"
                            [(ngModel)]="depotObject.country" [listUrl]="country_url+'country/?name=::search::'"
                            (ngModelChange)="filterStatebyCountryID($event)" fxFlex="100" [displayField]="'name'"
                            [errors]="errorObj.country" [idField]="null">
                        </app-mat-auto-search>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>State*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [name]="'state'" [listUrl]="stateUrl"
                            fxFlex="100" [(ngModel)]="depotObject.state" [displayField]="'name'"
                            [errors]="errorObj.state" [idField]="null" [disabled]="stateDisabled">
                        </app-mat-auto-search>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Full Address*</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [(ngModel)]="depotObject.address" [name]="'address'"
                            [isMultiline]="true" [minlength]="5" [errors]="errorObj.address" class="margint1">
                        </app-text-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Agreement Valid Till*</span>
                        </div>
                        <app-date-field [isEditable]="isEditable" [minDate]="currentDate"
                            [name]="'agreement_valid_date'" [(ngModel)]="depotObject.agreement_valid_date" fxFlex="100"
                            [errors]="errorObj.agreement_valid_date">
                        </app-date-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Billing Cycle*</span>
                        </div>
                        <app-select-field [isEditable]="isEditable" [(ngModel)]="depotObject.location_billing_type"
                            [idField]="null" [name]="'location_billing_type'" [options]="dd_billDepots?.results"
                            [displayField]="'value'" [errors]="errorObj.location_billing_type">
                        </app-select-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Depot email</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [(ngModel)]="depotObject.location_email"
                            [name]="'location_email'" [minlength]="5" [errors]="errorObj.location_email">
                        </app-text-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Depot Contact</span>
                        </div>
                        <app-number-field [isEditable]="isEditable" [(ngModel)]="depotObject.location_contact_no"
                            [name]="'location_contact_no'" [minValue]="0" [errors]="errorObj.location_contact_no">
                        </app-number-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Approachable via</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [name]="'connectivities'" [multiple]="true"
                            [displayField]="'name'" [defaultChip]="false" [(ngModel)]="depotObject.connectivities"
                            [setSearchValue]="false" [idField]="null" [options]="dd_approachableVia?.results"
                            class="align-items-center approachVia" [errors]="errorObj.connectivities">
                        </app-mat-auto-search>
                    </div>

                    <!-- <app-select-field fxFlex="26.4em" [isEditable]="isEditable" [label]="'Approachable via'"
                        [(ngModel)]="depotObject.connectivities" [name]="'connectivities'" [multiple]="true"
                        [searchable]="false" [displayField]="'name'" [idField]="null"
                        [options]="dd_approachableVia?.results" [errors]="errorObj.connectivities">
                    </app-select-field> -->

                    <div fxFlex="100" fxFlex.gt-xs="13.3em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Gate Opening - Gate Closing</span>
                        </div>
                        <div class="gate-time" fxLayout="row" *ngIf="isEditable">
                            <input [format]="24" [ngxTimepicker]="toggleIcon" [disableClick]="true"
                                [(ngModel)]="depotObject.working_hrs_from" (ngModelChange)="fromTimeFunc($event)">
                            <ngx-material-timepicker-toggle [for]="toggleIcon" class="setin">
                                <i id="clock" class="flaticon-clock" ngxMaterialTimepickerToggleIcon></i>
                            </ngx-material-timepicker-toggle>
                            <ngx-material-timepicker #toggleIcon
                                [defaultTime]="depotObject.working_hrs_from"></ngx-material-timepicker>

                            <input [format]="24" [ngxTimepicker]="toggleIcon1" [disableClick]="true" class="ialign"
                                [(ngModel)]="depotObject.working_hrs_to" (ngModelChange)="toTimeFunc($event)">
                            <ngx-material-timepicker-toggle [for]="toggleIcon1" class="setinn">
                                <i id="clock" class="flaticon-clock" ngxMaterialTimepickerToggleIcon></i>
                            </ngx-material-timepicker-toggle>
                            <ngx-material-timepicker #toggleIcon1></ngx-material-timepicker>

                        </div>
                        <span class="depot-port" *ngIf="errorObj.working_hrs_to">{{errorObj.working_hrs_to}} </span>

                        <div *ngIf="!isEditable" class="gateLable">
                            <label>{{depotObject.working_hrs_from}} -
                                {{depotObject.working_hrs_to}}</label>
                        </div>
                    </div>

                    <!-- <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Primary Contact Name</span>
                        </div>
                        <app-text-field [data]="" [isEditable]="isEditable" 
                         [minlength]="3" [name]="'local_name'" [maxlength]="100" [minlength]="5">
                        </app-text-field>
                    </div> -->

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" class="depotImgInput">
                        <div class="Logohead">
                            <span>Depot Logo</span>
                        </div>
                        <div class="depotImg">
                            <!-- <img [src]="depotObject?.logo?.document_file" width="100%"> -->
                            <img [src]="depotObject.logo ? depotObject.logo.document_file : depotImg " widh="100%">
                            <ng-container *ngIf="isEditable">
                                <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="false"
                                    [cameraIcon]="isEditable" [(ngModel)]="depotObject.logo" [multiple]="false"
                                    [documentTypeDevName]="'location_master_logo'" [name]="'logo'">
                                </app-file-field>
                            </ng-container>
                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-flex-start">
                        <div class=" inputTitle sToggle">
                            <mat-slide-toggle color="primary" [class.show]="isWeekendOpen"
                                [class.hideCheckbox]="!isEditable" [checked]="depotObject.week_offs"
                                (change)="openWeekend(depotObject.week_offs)" [disabled]="!isEditable">
                                Week-offs
                            </mat-slide-toggle>
                        </div>
                        <!-- add showWeekoff only -->
                        <mat-form-field id="day" class="noShow weekoff" [class.show]="showWeekoff" appearance="outline"
                            *ngIf="isEditable">
                            <mat-select [(ngModel)]="depotObject.week_offs" multiple>
                                <mat-option value="MONDAY">MONDAY</mat-option>
                                <mat-option value="TUESDAY">TUESDAY</mat-option>
                                <mat-option value="WEDNESDAY">WEDNESDAY</mat-option>
                                <mat-option value="THURSDAY">THURSDAY</mat-option>
                                <mat-option value="FRIDAY">FRIDAY</mat-option>
                                <mat-option value="SATURDAY">SATURDAY</mat-option>
                                <mat-option value="SUNDAY">SUNDAY</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- <span *ngIf="isWeekoffs">Select at least one week off" on click of save basic details.</span> -->
                        <div *ngIf="!isEditable" class="toggleView">
                            <ul>
                                <li *ngFor="let item of depotObject.week_offs">{{item}} </li>
                            </ul>
                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="18.3em" fxLayout="column" class="EDI align-items-flex-start">
                        <div class=" inputTitle sToggle">
                            <mat-slide-toggle color="primary" [class.show]="isEdiOpen" [checked]="depotObject.edi_code"
                                (change)="openEdi(depotObject.is_edi_available)" [class.hideCheckbox]="!isEditable"
                                [(ngModel)]="depotObject.is_edi_available" [disabled]="!isEditable">
                                Is EDI connectivity avaliable?
                            </mat-slide-toggle>
                        </div>
                        <!-- <mat-form-field id="edi" class="noShow" [class.show]="depotObject.edi_code" appearance="outline"
                            *ngIf="isEditable">
                            <input matInput [(ngModel)]="depotObject.edi_code" placeholder="EDI Code">
                        </mat-form-field> -->
                        <!-- <div id="edi" class="EDI noShow" [class.show]="depotObject.edi_code"> -->

                        <ng-container *ngIf="isEditable ">
                            <app-text-field id="edi" class=" noShow align-items-center" appearance="outline"
                                [class.show]="showEdi" [isEditable]="isEditable" [label]="''"
                                [(ngModel)]="depotObject.edi_code" [name]="'edi_code'" [minlength]="5"
                                placeholder="EDI Code">
                            </app-text-field>
                        </ng-container>

                        <div *ngIf="!isEditable" class="toggleView">
                            <label>{{depotObject.edi_code}}</label>
                        </div>
                    </div>


                    <app-remarks fxLayout="row wrap" [isEditable]="isEditable" [placeholder]="'Enter your remark here.'"
                        [(ngModel)]="depotObject.remarks" [commentDate]="depotObject.created_at"
                        [updatedBy]="depotObject.updated_by"
                        [commentDate]="depotObject?.updated_by?.picture?.updated_at" [headLabel]="false">
                    </app-remarks>

                    <div class="ai-fxs introCheck" fxFlex="100" fxLayout="column" *ngIf="isEditable && depotObject.id">
                        <section>
                            <mat-checkbox color="primary" [(ngModel)]="depotObject.is_active" checked
                                [disabled]="!isEditable">Active
                            </mat-checkbox>
                        </section>
                    </div>
                    <!-- <ng-container *ngIf="isEditable" class="btnb">
                        <div *ngIf="!savedBasic || wasedit" fxFlex="100" class="introButton">
                            <button mat-raised-button class="sleekBtn Save" (click)="saveBasic()"> Save Basic
                                Details</button>
                        </div>
                    </ng-container> -->

                </div>
            </div>

            <div class="content form-group" id="card2" fxLayout="column wrap">
                <!-- *ngIf="savedBasic && !loader" -->
                <ng-container>
                    <div class="headContent d-flex justify-content-between">
                        <span class="head"> <b> Depot- Port Mapping</b></span>
                        <button *ngIf="isEditable" mat-stroked-button (click)="Defaultport()"
                            class="sleekBtn clickIt addBtn">Add</button>
                    </div>
                    <!-- <div fxFlex="100" class="inputs" fxLayout="row wrap">
                <div class="btn" fxLayout="column" *ngIf="isEditable">
                    <button mat-stroked-button (click)="Defaultport()">Add</button>
                </div>
            </div> -->
                    <mat-divider></mat-divider>

                    <div>
                        <span class="depot-port">{{errorObj.is_primary}} </span>
                    </div>
                    <div fxFlex="100" class="inputs depotInput" fxLayout="row wrap">
                        <div fxFlex="100" class="p-lr-2rem" fxLayout="row wrap">
                            <!-- flipping card 1 unit, replicate this to create new one-->
                            <div class="flip-card" *ngFor="let item of locationPorts, let i = index">
                                <div id="fci{{i}}" class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <img id="cardBg" src="assets/images/demo/flipcard-bg1.jpg" alt="">
                                        <div class="distCard">
                                            <div>
                                                <i class="flaticon-ribbon prime" [class.hidden]="!item.is_primary"></i>
                                                <i class="flaticon-pencil" (click)="edit(i)"></i>
                                            </div>
                                            <p>
                                                {{item?.port?.name_display}}
                                            </p>
                                            <div class="ikm">
                                                <label for="km"> {{item.distance_in_km}}
                                                    KMs</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flip-card-back">
                                        <div class="distCard">
                                            <div>
                                                <mat-slide-toggle color="primary" [(ngModel)]="item.is_primary"
                                                    [disabled]="!isEditable">
                                                    Primary
                                                </mat-slide-toggle>
                                                <!-- <i class="flaticon-tick" (click)="onPortsSave(item,i)"></i> -->
                                            </div>
                                            <div class="ikm">
                                                <app-mat-auto-search [isEditable]="isEditable"
                                                    [placeholder]="'Select Port'" [name]="'port'"
                                                    [displayField]="'name_display'" [setSearchValue]="false"
                                                    [listUrl]="base_url+'location/?location_type_name=port&search=::search::'"
                                                    [(ngModel)]="item.port" fxFlex.gt-xs="19em" fxLayout="column"
                                                    class="align-items-center" [errors]="item.errorObj?.port"
                                                    [beLight]="true">
                                                </app-mat-auto-search>
                                                <!-- [options]="dd_ports?.results" -->
                                                <div class="ikmBox">
                                                    <app-number-field [isEditable]="isEditable" [label]="'KMs'"
                                                        [maxlength]="5" [(ngModel)]="item.distance_in_km" [minValue]="0"
                                                        [name]="'distance_in_km'" fxFlex.gt-xs="45" fxLayout="column"
                                                        [errors]="item.errorObj?.distance_in_km" [beLight]="true">
                                                    </app-number-field>
                                                    <span>KMs</span>
                                                    <mat-checkbox color="primary" [(ngModel)]="item.is_active"
                                                        [disabled]="!isEditable">Active</mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="btnb-fp" fxFlex="100">
                    <button class="bck" mat-raised-button (click)="backToList()">Back</button>
                    <button *ngIf="!isEditable" type="submit" mat-raised-button class="nxt" mat-stroked-button (click)="scrolltop()"
                        cdkStepperNext>Continue</button>
                    <ng-container *ngIf="isEditable">
                        <!-- *ngIf="!savedBasic || wasedit" -->
                        <div>
                            <button mat-raised-button class="nxt" mat-stroked-button
                              (click)="saveBasic();scrolltop()"> Save Basic
                                Details</button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </cdk-step>
    <cdk-step>
        <div id="top"></div>
        <ng-template cdkStepLabel>Depot Communication</ng-template>
        <div class="proBg">
            <mat-progress-bar id="progressBar1" class="progressSlider" mode="determinate" value="{{counter1}}">
            </mat-progress-bar>
        </div>
        <div action="" fxLayout="column wrap" class="formLayout form1">
            <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
            <div class="content form-group" id="card3" fxLayout="column wrap" *ngIf="!loader">
                <div class="headContent" fxFlex="100">
                    <h5>
                        Depot Directory
                    </h5>
                </div>
                <app-contact-table [dataSource]="_contacts" [isEditable]="isEditable"
                    (patchContactForm)="editContact($event)" (viewContactForm)="editable($event)"
                    (clearErrorsOnFormOpen)="clearError($event)" [forceRefresh]="refreshTable">
                </app-contact-table>
            </div>
            <div class="content form-group" id="card4" fxLayout="column wrap" *ngIf="!loader">
                <div class="headContent" fxFlex="100">
                    <h5>
                        Documents
                    </h5>
                </div>
                <div class="doc_details" fxFlex="100" fxLayout="row wrap">
                    <div fxFlex="100" fxLayout="column" class="doc_box">
                        <div class="flexSpaceBtwn" fxFlex="100" fxLayout="row">

                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Effective from*</span>
                                </div>
                                <app-date-field [isEditable]="isEditable" [name]="'effective_from_date'"
                                    [(ngModel)]="documentObject.effective_from_date"
                                    [errors]="errorObj.effective_from_date">
                                </app-date-field>
                            </div>

                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Effective till</span>
                                </div>
                                <app-date-field [isEditable]="isEditable" [name]="'effective_to_date'"
                                    [(ngModel)]="documentObject.effective_to_date" [minDate]="currentDate"
                                    [errors]="errorObj.effective_to_date">
                                </app-date-field>
                            </div>
                        </div>

                        <div class="uploadbtn" fxFlex="100">
                            <app-file-field [isEditable]="isEditable" [(ngModel)]="documentObject.document"
                                [documentTypeGroup]="'depot_document_type'" label="Select Documents"
                                [fileDropArea]="false" [name]="'document'" fxLayout="row" fxFlex="75"
                                [showUploadedList]="false" class="justify-content-flex-end align-items-center"
                                [errors]="errorObj.document" [lableUpload]="true" [multiple]="false">
                            </app-file-field>
                            <button class="nxt" [class.nxtColor]="isEditable"
                                [disabled]="!isEditable || documentObject.document==null" mat-raised-button
                                (click)="saveDocuments()">Save
                                Upload</button>
                            <ng-container *ngIf="!isEditable" class="btnb">
                            </ng-container>
                        </div>
                        <span class="uploadedDepotDoc"
                            *ngIf="documentObject?.document?.original_filename && isEditable">Selected:
                            <b>{{documentObject?.document?.original_filename}}.{{documentObject?.document?.extension}}</b></span>

                        <div class="table-responsive doc_table">
                            <mat-table [dataSource]="_documents" matSort (matSortChange)="announceSortChange($event)"
                                class="">
                                <ng-container matColumnDef="document">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header> Document </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <a [href]='element?.document?.document_file' target="_blank"
                                            [download]="element?.document?.original_filename+'.'+element?.document?.extension">
                                            {{element?.document?.original_filename}}.{{element?.document?.extension}}</a>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="document_type">
                                    <mat-header-cell *matHeaderCellDef> Document Type </mat-header-cell>
                                    <mat-cell *matCellDef="let element"> {{element.document?.document_type?.name}}
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="effective_from_date">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header> Effective From
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element"> {{element.effective_from_date |
                                        date:
                                        'dd MMM, yyyy'}} </mat-cell>
                                </ng-container>

                                <!-- <ng-container matColumnDef="effective_to_date">
                                        <mat-header-cell *matHeaderCellDef> Effective To Date </mat-header-cell>
                                        <mat-cell *matCellDef="let element"> {{element.effective_to_date |
                                            date:
                                            'dd MMM, yyyy'}} </mat-cell>
                                    </ng-container> -->


                                <ng-container matColumnDef="created_by">
                                    <mat-header-cell *matHeaderCellDef> Uploaded by </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <div class="details" fxLayout="column">
                                            <span>
                                                {{element?.document?.created_by?.first_name}}
                                                {{element?.document?.created_by?.last_name}}
                                            </span>
                                            <small>
                                                {{element?.created_at | date:'dd MMM, yyyy'}}
                                            </small>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <!-- <ng-container matColumnDef="created_at">
                                        <mat-header-cell *matHeaderCellDef> Uploaded on </mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            <div class="details" fxLayout="column">
                                                <small>
                                                    {{element?.created_at | date:'dd MMM, yyyy'}}
                                                </small>
                                            </div>
                                        </mat-cell>
                                    </ng-container> -->

                                <ng-container matColumnDef="isEdit">
                                    <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let idx = index;">
                                        <button mat-icon-button [matMenuTriggerFor]="menu"
                                            aria-label="Example icon-button with a menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item>
                                                <a [href]='element?.document?.document_file' target="_blank"
                                                    [download]="element?.document?.original_filename+'.'+element?.document?.extension">
                                                    <span>Download File</span>
                                                </a>
                                            </button>
                                            <button mat-menu-item (click)="deleteDocument(element)"
                                                [disabled]="!isEditable">
                                                <span>Delete File</span>
                                            </button>
                                        </mat-menu>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
                            </mat-table>
                        </div>


                    </div>
                </div>
                <div class="btnb" fxFlex="100" fxLayout="row">
                    <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                    <button type="submit" class="nxt" mat-stroked-button cdkStepperNext
                        (click)="scrolltop()">Next</button>
                </div>
            </div>
            <ng-container *ngIf="isshowBulk">
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <div class="content form-group" id="card4" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent">
                        <span class="head"><b> Upload Data</b> </span>
                    </div>
                    <bulk-data></bulk-data>
                    <div class="btnb1" fxFlex="100">
                        <button class="bck" mat-raised-button cdkStepperPrevious class="bck">Back</button>
                        <button class="nxt" mat-stroked-button cdkStepperNext (click)="saveUpload()">Save
                            Upload</button>
                    </div>
                </div>
            </ng-container>
        </div>
    </cdk-step>
    <cdk-step>
        <ng-template cdkStepLabel>Depot Commercials </ng-template>
        <div class="form3" action="">
            <div class="formLayout" *ngIf="!isshowCmplt">
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>

                <div class="content form-group" id="card6" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent" fxFlex="100">
                        <h5>
                            Man-Hour Costs
                        </h5>
                    </div>
                    <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Man-Hour charge*</span>
                            </div>
                            <logzy-money-field [isEditable]="isEditable" [maxlength]="10"
                                [(amount)]="manhourchargeObject.man_hour_charges"
                                [(currencyCode)]="manhourchargeObject.man_hour_charges_currency"
                                [errors]="errorObj.man_hour_charges">
                            </logzy-money-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Effective from date*</span>
                            </div>
                            <app-date-field [isEditable]="isEditable" [name]="'effective_from_date'"
                                [(ngModel)]="manhourchargeObject.effective_from_date"
                                [errors]="errorObj.effective_from_date">
                            </app-date-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Effective to date</span>
                            </div>
                            <app-date-field [isEditable]="isEditable" [name]="'effective_to_date'"
                                [(ngModel)]="manhourchargeObject.effective_to_date" [minDate]="currentDate"
                                [errors]="errorObj.effective_to_date">
                            </app-date-field>
                        </div>

                        <div fxLayout="row wrap" fxFlex="100" class="justify-content-flex-end">
                            <button mat-raised-button [disabled]="!isEditable" [class.mChargeSave]="isEditable"
                                (click)="onSaveManHourCharge()">Save</button>
                        </div>
                    </div>
                </div>

                <div class="content form-group" id="card5" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                        <h5>
                            Operational charges
                        </h5>
                        <div fxLayout="row wrap" class="addOpr">
                            <app-select-field *ngIf="isEditable" [isEditable]="isEditable" [trim]="true"
                                [idField]="null" [(ngModel)]="selectedDepotOptionalCharge"
                                [name]="'selected_optional_charge'" [displayField]="'charge_head'"
                                [disabled]="isAddOpChargeDisabled" [options]="depotOptionalChargeList" fxFlex="100"
                                fxFlex.gt-xs="18.3em" fxLayout="column" class="align-items-center">
                            </app-select-field>
                            <button mat-raised-button (click)="addRow(selectedDepotOptionalCharge)"
                                [class.Save]="isEditable" [disabled]="!isEditable">Add</button>
                        </div>
                    </div>
                    <div class="op-charges" fxFlex="100" fxLayout="row wrap">
                        <div class="table-responsive">
                            <mat-table [dataSource]="operationalChargeData">
                                <ng-container matColumnDef="charge_name">
                                    <mat-header-cell *matHeaderCellDef> Charge Name </mat-header-cell>
                                    <mat-cell *matCellDef="let element">{{element?.charge?.charge_head}}</mat-cell>
                                </ng-container>

                                <ng-container *ngFor="let col of operationalChargeTable?.depot_charges; let i = index;"
                                    [matColumnDef]="col?.container_size?.size+'_'+col?.container_type_group?.name">
                                    <mat-header-cell *matHeaderCellDef>
                                        {{col?.container_size?.size}} {{col?.container_type_group?.name}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let j=index;">
                                        <app-number-field [isEditable]="element.isEdit"
                                            [(ngModel)]="element?.operational_charges[i].charge_rate"
                                            [name]="'charge_rate'+i" [minValue]="0" [maxValue]="99999" [maxlength]="10"
                                            fxFlex="100" fxLayout="column"
                                            [errors]="opChargeErrors?.operational_charges[j][i]?.charge_rate">
                                        </app-number-field>
                                        <!-- <i class="flaticon-save" *ngIf="element.isEdit"
                                            (click)="saveOpCharge(element,i)"></i> -->
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="charge_rate_currency">
                                    <mat-header-cell *matHeaderCellDef> Currency </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let j=index;">
                                        <app-mat-auto-search [isEditable]="element.isEdit"
                                            [(ngModel)]="opChargeCurrency[j]" [name]="'charge_rate_currency'+j"
                                            [idField]="'currency_code'" [listUrl]="currencyUrl"
                                            [displayField]="'currency_code'" fxFlex="100" fxLayout="column" lass="pl-0"
                                            class="align-items-center">
                                        </app-mat-auto-search>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                                    <mat-cell *matCellDef="let element; let idx = index;">
                                        <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="!isEditable"
                                            aria-label="Example icon-button with a menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item [disabled]="element.isEdit"
                                                (click)="editOpCharge(element)">
                                                Edit
                                            </button>
                                            <button mat-menu-item [disabled]="!element.isEdit"
                                                (click)="saveOpCharge(element,idx)">
                                                Save
                                            </button>
                                            <button mat-menu-item (click)="removeCharge(element)">
                                                Remove Charge
                                            </button>
                                        </mat-menu>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="operationalChargeDisplayColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: operationalChargeDisplayColumns;"></mat-row>
                            </mat-table>
                        </div>
                    </div>
                </div>

                <div class="content form-group" id="card8" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                        <h5>
                            Storage charges
                        </h5>
                        <!-- <div class="setBtn">
                            <button mat-raised-button (click)="expandToggle($event)"><i MatSuffix
                                    class="flaticon-maximize"></i></button>
                            <button mat-raised-button><i MatSuffix class="flaticon-copy"></i></button>
                        </div> -->
                    </div>
                    <div fxFlex="100" class="inputs inputMaxWidth " fxLayout="row wrap">
                        <div fxFlex="100" fxLayout="row wrap" class="temp">

                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Free Storage up to (TEUs)</span>
                                </div>
                                <app-number-field [isEditable]="isEditable" [maxlength]="5" [minValue]="0"
                                    [(ngModel)]="depotObject.free_storage_days_upto_teus" name="thereafter_charge_rate"
                                    class="align-items-center" placeholder="TEU">
                                </app-number-field>
                            </div>
                            <mat-accordion *ngFor="let item of storage_charge; let i = index"
                                class="example-headers-align" multi>
                                <mat-expansion-panel class="ep-1">
                                    <mat-expansion-panel-header class="accordian">
                                        <mat-panel-title>
                                            {{item.container_size_display}}"FT
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-divider></mat-divider>
                                    <div class="panel" id="p0">
                                        <div class=" form-group" id="card9" fxLayout="row">
                                            <div fxFlex="100" class="op-charges" fxLayout="row wrap">
                                                <div class="vstack">
                                                    <div class="hstack">
                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Storage Currency*</span>
                                                            </div>
                                                            <app-mat-auto-search [isEditable]="isEditable"
                                                                [displayField]="'currency_code'" [name]="'currency'"
                                                                [(ngModel)]="item.currency" [idField]="'currency_code'"
                                                                [listUrl]="currencyUrl" [errors]="errorObj.currency">
                                                            </app-mat-auto-search>
                                                        </div>

                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Effective From Date</span>
                                                            </div>
                                                            <app-date-field [isEditable]="isEditable"
                                                                [minDate]="currentDate"
                                                                [(ngModel)]="item.effective_from_date"
                                                                [name]="'agreement_valid_date'">
                                                            </app-date-field>
                                                        </div>
                                                    </div>
                                                    <div class="hstack addingSlab">
                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Free Days</span>
                                                            </div>
                                                            <app-number-field [isEditable]="isEditable"
                                                                placeholder="Days" [maxlength]="3" [minValue]="0"
                                                                [name]="'free_days'" [(ngModel)]="item.free_days"
                                                                [errors]="errorObj.free_days" [noDecimal]="true">
                                                            </app-number-field>
                                                        </div>
                                                        <button class="AddFreeDays" mat-raised-button
                                                            (click)="addSlabs(i)" *ngIf="isEditable">Add
                                                            Slab</button>
                                                    </div>

                                                    <div class="hstack borderDef"
                                                        *ngFor="let value of item.slabs; let j = index">
                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Next</span>
                                                            </div>
                                                            <app-number-field [data]="" [isEditable]="isEditable"
                                                                placeholder="Days" [(ngModel)]="value.days" name="days"
                                                                [maxlength]="4" [minValue]="0" [noDecimal]="true"
                                                                [errors]="errorObj.days">
                                                            </app-number-field>
                                                            <span *ngIf="!isEditable" class="numFieldSpan">Days</span>
                                                        </div>

                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Rate</span>
                                                            </div>
                                                            <app-number-field [isEditable]="isEditable" [maxlength]="5"
                                                                [(ngModel)]="value.charge_rate" name="charge_rate"
                                                                placeholder="Rate" [minValue]="0"
                                                                [errors]="errorObj.charge_rate">
                                                            </app-number-field>
                                                            <span *ngIf="!isEditable"
                                                                class="numFieldSpan">{{item.currency}}</span>
                                                        </div>
                                                        <i class="flaticon-delete AddFreeDays"
                                                            (click)="removevalue(i,j)" *ngIf="isEditable"></i>
                                                    </div>
                                                    <div class="hstack justify-content-between scSave">
                                                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                                            <div class="inputTitle">
                                                                <span>Henceforth*</span>
                                                            </div>
                                                            <app-number-field [isEditable]="isEditable" [maxlength]="5"
                                                                [(ngModel)]="item.thereafter_charge_rate"
                                                                name="thereafter_charge_rate" [maxlength]="10"
                                                                placeholder="Henceforth rate" [minValue]="0"
                                                                [errors]="errorObj.thereafter_charge_rate">
                                                            </app-number-field>
                                                            <!-- <span *ngIf="!isEditable"
                                                                class="numFieldSpan">{{item.currency}}</span> -->
                                                        </div>
                                                        <button mat-raised-button type="button"
                                                            (click)="postStorageCharges(item)" class="Save AddFreeDays"
                                                            *ngIf="isEditable">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                        <div class="btns" fxFlex="100">
                            <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                            <button mat-stroked-button class="nxt" (click)="complete()">Done</button>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="isshowCmplt">
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <div class="content form-group" id="card7" fxFlayout="column wrap" *ngIf="!loader">
                    <div class="bgImg" fxFlex="36.85em">
                        <img id="complete" src="assets/images/backgrounds/container_save_success.png" alt="">
                    </div>
                    <div class="cmpltTxt" fxFlex="100">
                        <div>
                            <span>Depot details saved successfully.</span>
                        </div>
                    </div>
                    <div class="btn" fxFlex="100">
                        <button mat-stroked-button class="nxt" (click)="testReload()">
                            <div>
                                <i MatSuffix id="i1" class="flaticon-dashboard"></i>
                                <span>Go to List </span>
                            </div>
                        </button>
                        <button mat-stroked-button class="nxt" (click)="testReload1()">
                            <div>
                                <i MatSuffix id="i1" class="flaticon-depot"></i>
                                <span>Add a Depot </span>
                            </div>
                        </button>

                    </div>
                </div>
            </ng-container>
        </div>
    </cdk-step>
</cdk-depot-stepper>